import useAuth from 'app/hooks/useAuth';

import { collection, getFirestore, onSnapshot } from 'firebase/firestore';
import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { userInstagramStateAtom, userPinterestStateAtom } from '../atom';

const usePinsta = () => {
  const setUserPinterests = useSetRecoilState(userPinterestStateAtom);
  const setInstagrams = useSetRecoilState(userInstagramStateAtom);
  const { user } = useAuth();

  useEffect(() => {
    const uid = user?.uid;
    if (!uid) return;

    const unsubscribeInstagram = onSnapshot(
      collection(getFirestore(), 'userData', uid, 'instagram'),
      (snapshot) => {
        let nInstagrams = [];
        snapshot.forEach((doc) => {
          nInstagrams.push({ ...doc.data(), id: doc.id });
        });
        setInstagrams(nInstagrams);
      }
    );

    const unsubscribePinterest = onSnapshot(
      collection(getFirestore(), 'userData', uid, 'pinterest'),
      (snapshot) => {
        let nPinterests = [];
        snapshot.forEach((doc) => {
          nPinterests.push({ ...doc.data(), id: doc.id });
        });
        setUserPinterests(nPinterests);
      }
    );

    return () => {
      unsubscribeInstagram();
      unsubscribePinterest();
    };
  }, [user?.uid]);

  return null;
};

export default usePinsta;
